export enum ModalTransitions {
    Fade,
    None,
    SlideRight,
    SlideUp,
}
